module.exports = __webpack_public_path__ + "img/heijiaoniurou.6e03e045.jpg";